import(/* webpackMode: "eager", webpackExports: ["SupabaseAuthProvider"] */ "/vercel/path0/components/auth/supabase-auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/components/layout/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompactGlobalSidebar"] */ "/vercel/path0/components/layout/compact-global-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary","withErrorBoundary"] */ "/vercel/path0/components/layout/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InlineLoading","LoadingTransition"] */ "/vercel/path0/components/layout/loading-transition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalHeader"] */ "/vercel/path0/components/layout/portal-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeComponent"] */ "/vercel/path0/components/layout/safe-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationGuardProvider","useNavigationGuardContext"] */ "/vercel/path0/components/providers/navigation-guard-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/components/providers/query-client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuickThemeActions"] */ "/vercel/path0/components/theme/theme-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/lib/theme/theme-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"lib/fonts/inter.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/Inter-Variable.woff2\",\"display\":\"swap\",\"variable\":\"--font-inter\",\"weight\":\"100 900\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
